import { useSelector } from 'react-redux';

import { selectAccountSlug } from '@/redux/session/selectors';

import { findDialogOfNode, useDialogsList } from './useDialogsList';
import { useLeaveModal } from './useLeaveModal';
import { selectBrainId } from '../redux/selectors';

type DialogNodeLink = { to: string; goTo: () => void };

/**
 * Deep-links to the dialog hosting `nodeId`, closing the modal.
 * `null` while the dialogs cache is resolving, so callers can fall back to text.
 */
export const useGoToDialogNode = (nodeId?: string): DialogNodeLink | null => {
  const leaveModal = useLeaveModal();
  const slug = useSelector(selectAccountSlug);
  const brainId = useSelector(selectBrainId);
  const dialogs = useDialogsList();

  const dialogId = findDialogOfNode(dialogs, nodeId)?.dialog_id ?? null;

  if (!slug || !brainId || !dialogId) {
    return null;
  }

  const to = `/${slug}/ai-agents/${brainId}/workflows/dialogs/${dialogId}?node=${encodeURIComponent(
    nodeId as string
  )}`;

  return { to, goTo: () => leaveModal(to) };
};
